import styled from 'styled-components';

import { device } from 'vqp-common';

export const Button = styled.button`
  background-color: #ffffff;
  border-style: solid;
  border-radius: 5px;
  border-size: 1px;
  border-width: 1px;
  width: ${(props) => (props.stretch ? '100%' : '128px')};
  height: 30px;
  font-size: 12px;
  line-height: 12px;
  transition: all 0.15s ease;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  @media ${device.desktop} {
    font-size: ${(props) => (props.big ? '16px' : '13px')};
    width: ${(props) => props.width || '152px'};
    padding: 5px;
  }

  &:hover:not(:disabled):not(.primary):not(.error):not(.secondary):not(.success):not(.back) {
    background-color: ${(props) => props.theme.colors?.lightGrey || '#f5f5f5'};
  }

  &.default {
    border-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.primary};
    &:hover {
      background-color: ${(props) => props.theme.colors.primary};
      color: white;
    }
  }

  &.default-error {
    border-color: ${(props) => props.theme.colors.error};
    color: ${(props) => props.theme.colors.error};
    margin-right: 10px;

    &:hover {
      color: ${(props) => props.theme.colors.textError};
    }
  }

  &.export {
    border-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.primary};
    margin-right: 10px;
    &:hover {
      background-color: ${(props) => props.theme.colors.primary};
      color: black;
    }
  }

  &.hollow {
    color: ${(props) => props.theme.colors.textPrimary};
    border: none;
    background-color: none;
  }

  &.primary {
    border-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.primary};
    background-color: ${(props) => props.theme.colors.primary};
    color: white;
    &:hover:not(:disabled) {
      filter: brightness(1.08);
    }
    &:disabled {
      opacity: 0.4;
      pointer-events: none;
    }
  }

  &.secondary {
    border-color: ${(props) => props.theme.colors.secondary};
    color: ${(props) => props.theme.colors.secondary};
    background-color: ${(props) => props.theme.colors.secondary};
    color: white;
    &:hover {
    }
    &:disabled {
      opacity: 0.4;
      pointer-events: none;
    }
  }

  &.success {
    background-color: ${(props) => props.theme.colors.success};
    border-color: ${(props) => props.theme.colors.success};
    color: white;
    &:hover {
    }

    &:disabled {
      opacity: 0.4;
      pointer-events: none;
    }
  }

  &.error {
    background-color: ${(props) => props.theme.colors.error};
    border-color: ${(props) => props.theme.colors.error};
    color: white;
    &:hover {
      filter: brightness(1.08);
    }
  }

  &.back {
    background-color: ${(props) => props.theme.colors.mediumGrey};
    border-color: ${(props) => props.theme.colors.mediumGrey};
    color: white;
    &:hover {
    }
  }

  &.outlined {
    border-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.primary};
    background-color: transparent;
  }

  &.animated:active {
    transform: scale(1.1);
    transition: none;
  }
`;
